<!-- @format -->

<index-tag>
  <div class="contents">
    <section class="contents_area">
      <div class="contents_block detail" style="text-align: center">
        <img src="/assets/img/logo.svg" style="max-width: 300px" />

        <div class="container_news-title" style="margin-top: 16px">
          ようこそ！
        </div>
        <!--/.container_news-title-->
        <p class="text margin-spacing-2_bottom">
          「EDILENT」は編集者、ライター専門のお仕事マッチングプラットフォームです。
        </p>
        <p class="text margin-spacing-2_bottom"></p>
        <p class="text margin-spacing-2_bottom"></p>
        <p class="text margin-spacing-2_bottom"></p>
        <p class="text margin-spacing-2_bottom">
          スキルや職業経験のほか、自身の制作実績（ポートフォリオ）を登録して受注率アップ！
        </p>
        <p class="text margin-spacing-2_bottom">
          是非この機会に、事前登録をご利用ください。
        </p>
        <p class="text margin-spacing-2_bottom"></p>
        <p class="text margin-spacing-2_bottom"></p>
        <p class="text margin-spacing-2_bottom">
          EDILENTのご利用にあたり、CROCO IDを取得いただいております。
        </p>
        <p class="text margin-spacing-2_bottom">
          下記リンクより、所定の項目をご記入のうえご登録をお願いいたします。
        </p>
        <p class="text margin-spacing-2_bottom">
          （すでにCROCO IDを取得いただいている方は
          <a onclick="{(e)=>goLogin(e)}">こちら</a>
          からログインをお願いいたします。）
        </p>

        <div class="box_flex03 margin-spacing-3_top">
          <div
            class="button button-secondary-large"
            type="button"
            value="CROCO IDを取得する"
            data-target=""
            onclick="{(e)=>goRegister(e)}"
          >
            CROCO IDを取得する
          </div>
        </div>
        <p class="text margin-spacing-2_bottom">
          ※こちらはお仕事を受託する編集者・ライター様専用の画面となります。
          <br />
          記事制作のご注文をご検討されているクライアント様は
          <a href="https://edilent-client.biz-samurai.com/lp/release.html">
            こちら
          </a>
          をご確認ください。
        </p>
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import di from "dependency-injection";

    export default {
      state: {
        api_host: null,
      },
      goLogin(e) {
        location.href =
          this.state.api_host +
          "/i/login?hfb=1&r=" +
          encodeURI(document.URL + "?login=1");
      },
      goRegister(e) {
        location.href =
          this.state.api_host +
          "/i/reg?r=" +
          encodeURI(document.URL + "?login=2");
      },
      onBeforeMount() {
        this.Api = di.createApi("register");
        this.Api.request("index", "fetch-api-host").then((data) => {
          this.state.api_host = data;
        });

        this.Api.request("index", "auth-info").then((data) => {
          switch (data) {
            case "has-client-id":
              di.router.push("/register/has-client-id");
              return;
            case "registered":
              location.href = "/menu";
              return;
            case "has-bizid":
              di.router.push("/register/agreement?r=/menu?login=2");
              return;
          }
        });
      },
    };
  </script>
</index-tag>
